/*
 * @Author: zhaopu
 * @Date: 2022-02-15 18:38:33
 * @LastEditors: zhaopu
 * @LastEditTime: 2022-02-16 10:53:58
 * @Description: 计划选择组件展示
 */
import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { dispatch, getState } from '@/store';
import useStore from '@/hooks/useStore.js';
import './index.less';

const InsurancePlanSelect = props => {
  const {
    dataSource = [],
    onChangePlan = () => {}
  } = props;
  const [PLAN_ID] = useStore('PLAN_ID');
  const [planId, setPlanId] = useState(PLAN_ID);

  const handleChange = planItem => {
    if (planItem.value === planId) return;
    setPlanId(planItem.value); // const currFormValues = getState('formValues');
    // const cacelFormValues = getState(`fvs._${planItem.value}`);
    // const obj = {
    //   // [`fvs._${currentPlan}`]: currFormValues,
    //   currentPlan: planItem.value,
    //   PLAN_ID: planItem.value,
    //   insurancePlan: planItem,
    //   CLAUSE_CHECKED: false,
    //   premium: undefined,
    //   formValues: {
    //     trailElement: [],
    //   },
    // };
    // dispatch(obj);

    onChangePlan(planItem);
  };

  const cls1 = cn('select-plan-container', {
    'bg-fff': true,
    'select-plan-container-scroll': dataSource.length > 3
  }); // useEffect(() => {
  //   const planItem = dataSource.find((i) => i.value === planId) || dataSource[0];
  //   if (planItem) {
  //     dispatch({
  //       insurancePlan: planItem,
  //       currentPlan: planItem.value,
  //       PLAN_ID: planItem.value,
  //     });
  //   }
  // }, []);

  const firstI = dataSource[0];
  return /*#__PURE__*/React.createElement("div", {
    className: "plan-select-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: cls1
  }, dataSource.map(item => {
    const cls = cn('select-plan-item', {
      'select-plan-item-active': planId === item.value || !planId && firstI.value === item.value,
      'select-plan-item-scroll': dataSource.length > 3
    });
    return /*#__PURE__*/React.createElement("div", {
      className: cls,
      onClick: () => {
        handleChange(item);
      }
    }, /*#__PURE__*/React.createElement("span", null, item.salesname));
  })));
};

export default InsurancePlanSelect;